import type { CustomClaims } from './types/CustomClaims';

export const formatFullName = (
  name: Pick<CustomClaims, 'given_name' | 'family_name'>
): string | null =>
  name.given_name && name.family_name
    ? `${name.given_name} ${name.family_name}`.trim()
    : null;
